/** @deprecated Import transport primitives from `bunderstack/client`. */
export {
  DEFAULT_KEEPALIVE_MS,
  DEFAULT_LIVENESS_FACTOR,
  isRealtimeHeartbeat,
  openRealtimeStream,
  type RealtimeAction,
  type RealtimeChange,
  type RealtimeEvent,
  type RealtimeHeartbeat,
  type RealtimeProcedure,
  type RealtimeStreamOptions,
  type RealtimeSyncHandle,
} from '../client/realtime'
